import db from './db.js';
import field from './field.js';
import { findByAttr } from './misc.js';

const _selectionCache = Object.create(null);

const grid = {

	id: null,
	view: null,
	node: null,
	visible: [],

	init(id, view, node)
	{
		this.id = id;
		this.view = view;
		this.node = node;
	},

	async render(records = [])
	{
		if (this.id)
			delete _selectionCache[this.id];
		const list = Array.isArray(records) ? records : [];
		this.node.innerHTML = await this.view.call(this, list);
		const viewEl = this.node.querySelector('.view');
		if (viewEl)
			viewEl.addEventListener('click', this.flipState.bind(this));
	},

	setVisible(indices)
	{
		this.visible = indices;
	},

	clearSelection()
	{
		if (this.id)
			delete _selectionCache[this.id];
		this.node?.querySelectorAll('.view input[type="checkbox"]').forEach(node => { node.checked = false; });
	},

	getSelection()
	{
		return _selectionCache[this.id] || [];
	},

	setSelection(selection)
	{
		if (this.id)
			_selectionCache[this.id] = selection;
	},

	isChecked(id)
	{
		return this.getSelection().includes(id) ? ' checked' : '';
	},

	flipState(ev)
	{

		if (ev.target.nodeName != 'INPUT' || ev.target.type != 'checkbox')
			return;

		ev.stopPropagation();

		if (ev.target.parentNode.nodeName == 'TH')
		{
			const table = ev.target.closest('.view');
			const rows = table?.querySelectorAll('tbody tr[data-id]') || [];
			const allIds = Array.from(rows).map(r => r.getAttribute('data-id'));
			const selection = this.getSelection();
			const allSelected = allIds.length > 0 && allIds.every(id => selection.includes(id));
			const headCb = table?.querySelector('thead input[type="checkbox"]');
			if (allSelected)
			{
				this.clearSelection();
				if (headCb) headCb.checked = false;
			}
			else
			{
				this.setSelection([...allIds]);
				table?.querySelectorAll('tbody input[type="checkbox"]').forEach(cb => { cb.checked = true; });
				if (headCb) headCb.checked = true;
			}
			return;
		}

		let id = findByAttr(ev.target, 'data-id').getAttribute('data-id');

		let selection = this.getSelection();

		if (ev.target.checked)
			selection.push(id);
		else
			selection.splice(selection.indexOf(id), 1);

		this.setSelection(selection);

	},

	async key(store, keys, labels = 'name', separator = ' ')
	{
		if (!keys || (Array.isArray(keys) && (keys.length === 0 || keys.some(v => v == null || v === ''))))
			return;
		let entry = await db.get(store, keys);
		if (!entry)
			return;
		return (Array.isArray(labels) ? labels : [labels]).map(label => entry[label]).join(separator);
	},

	option(object, value)
	{
		return object.options.find(entry => entry.value == value)?.label;
	},

	// TODO: Usar o campo já inicializado para o filtro para formatar o dado ao invés de ficar criando um novo a cada ocorrência
	// Dá erro de "Selector not found" quando sendo criado
	format(type, value)
	{
		return field.create({}, [type]).format(value);
	},

};

export default grid;

